import { useQuery } from "react-query";
import { getAllLaboratories } from "services/laboratory.service";

export default function useLaboratories(params?: {
  page?: number;
  limit?: number;
  search?: string;
}) {
  return useQuery(["laboratories", params], () => getAllLaboratories(params), {
    keepPreviousData: true,
  });
}
